import { DiagramValidationError, DiagramValidator } from './DiagramValidator';

import { DiagramComponentInstance } from './DiagramComponentInstance';
import { DiagramConnection } from './DiagramConnection';
import { Zone } from './Zone';
import { Diagram } from './Diagram';

export enum ZoneValidationErrorType {
    CONTROL_METHODS_NO_CONTROL_COMPONENT = 'CONTROL_METHODS_NO_CONTROL_COMPONENT',
    CONTROL_METHODS_NO_CONTROL_COMPONENT_M = 'CONTROL_METHODS_NO_CONTROL_COMPONENT_M',
    CONTROL_METHODS_NO_CONTROL_COMPONENT_Lp = 'CONTROL_METHODS_NO_CONTROL_COMPONENT_Lp',
    CONTROL_METHODS_NO_CONTROL_COMPONENT_Ln = 'CONTROL_METHODS_NO_CONTROL_COMPONENT_Ln',
    CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS = 'CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS',
    CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS_Lp_M = 'CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS_Lp_M',
    CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS_M_Ln = 'CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS_M_Ln',
    CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS_Lp_Ln = 'CONTROL_METHODS_MULTIPLE_VOLTAGE_CONTROL_COMPONENTS_Lp_Ln',
    CONTROL_METHODS_NO_CV_AND_DV_COMBINED = 'CONTROL_METHODS_NO_CV_AND_DV_COMBINED',
    CONTROL_METHODS_NO_CV_AND_DV_COMBINED_Lp_M = 'CONTROL_METHODS_NO_CV_AND_DV_COMBINED_Lp_M',
    CONTROL_METHODS_NO_CV_AND_DV_COMBINED_M_Ln = 'CONTROL_METHODS_NO_CV_AND_DV_COMBINED_M_Ln',
    CONTROL_METHODS_NO_CV_AND_DV_COMBINED_Lp_Ln = 'CONTROL_METHODS_NO_CV_AND_DV_COMBINED_Lp_Ln',
    VOLTAGE_LEVELS_MISMATCH = 'VOLTAGE_LEVELS_MISMATCH',
    VOLTAGE_NOMINAL_EXCEEDS_MAXIMUM = 'VOLTAGE_NOMINAL_EXCEEDS_MAXIMUM',
    CURRENT_NOMINAL_EXCEEDS_MAXIMUM = 'CURRENT_NOMINAL_EXCEEDS_MAXIMUM',
    VOLTAGE_TYPES_MISMATCH = 'VOLTAGE_TYPES_MISMATCH',
    VOLTAGE_TYPES_MISSING = 'VOLTAGE_TYPES_MISSING',
    GROUNDING_MISSING = 'GROUNDING_MISSING',
    GROUNDING_CONFIGURATION_MISSING = 'GROUNDING_CONFIGURATION_MISSING',
    GROUNDING_MULTIPLE = 'GROUNDING_CONFIGURATION_MULTIPLE',
    FAULT_ENDPOINT_VOLTAGE_MISSING = 'FAULT_ENDPOINT_VOLTAGE_MISSING',
    FAULT_ENDPOINT_CAPACITANCE_MISSING = 'FAULT_ENDPOINT_CAPACITANCE_MISSING',
    FAULT_CONNECTION_ZERO_RESISTANCE = 'FAULT_CONNECTION_ZERO_RESISTANCE',
    FAULT_CAPACITANCE_TOO_SMALL = 'FAULT_CAPACITANCE_TOO_SMALL',
    FAULT_CONNECTION_INDUCTANCE_MISSING = 'FAULT_CONNECTION_INDUCTANCE_MISSING',
    FAULT_NEGATIVE_VALUES = 'FAULT_NEGATIVE_VALUES',
}

export type ZoneValidationError = DiagramValidationError<
    ZoneValidationErrorType,
    {
        zone: Zone;
        componentInstances: DiagramComponentInstance[];
        connections?: DiagramConnection[];
        voltage?: {
            min?: number;
            nom?: number;
            max: number;
            minComponentInstances?: DiagramComponentInstance[];
            nomComponentInstances?: DiagramComponentInstance[];
            maxComponentInstances?: DiagramComponentInstance[];
        };
        current?: {
            nom: number;
            max: number;
            nomComponentInstances: DiagramComponentInstance[];
            maxComponentInstances: DiagramComponentInstance[];
        };
    }
>;

export type ZoneValidator = DiagramValidator<
    'zone',
    { diagram: Diagram; zones: Zone[] },
    ZoneValidationError,
    ZoneValidationErrorType
>;
